<template>
    <div>
        <div class="form-group bmd-form-group search-area m-0 mb-2">
            <div class="row">
                <div class="col-12 col-md-6 col-lg-6">
                    <div>
                        <span v-if="voucherType === 'buy' && voucher.outSourceName !== '' && !buyReturn" class="text-success">سند خرید از {{voucher.outSourceName}}</span>
                        <span v-if="voucherType === 'buy' && voucher.outSourceName !== '' && buyReturn" class="text-success">سند مرجوعی خرید از {{voucher.outSourceName}}</span>
                        <span v-if="voucherType === 'sell' && sellReturn" class="text-success">سند مرجوعی از
                        {{voucher.receiveOutSourceName}}</span>
                        <span v-if="voucherType === 'sell' && !sellReturn" class="text-success">                            سند فروش به
                        {{voucher.receiveOutSourceName}}</span>
                    </div>
                    <div>
                        <span>مبلغ کل: </span>
                        <span v-if="voucher !== undefined">{{voucher.overallPrice.toLocaleString()}}</span>
                        <span>پرداخت شده: </span><span>{{(voucher.overallPrice - remainingAmount).toLocaleString()}}</span>
                        <span>باقیمانده: </span><span>{{remainingAmount.toLocaleString()}}</span>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-6 text-left">
                    <!--<button v-if="remainingAmount === 0 && !hasCheck" class="btn btn-success mr-2" @click="onVoucherSubmitClicked">ثبت سند</button>-->
                    <button v-if="voucherType === 'buy' && !hasCheck && !buyReturn"
                            class="btn btn-success mr-2" @click="onVoucherSubmitClicked">ثبت خرید
                    </button>
                    <button v-if="voucherType === 'buy' && buyReturn"
                            class="btn btn-success mr-2" @click="onVoucherSubmitClicked">ثبت مرجوعی خرید
                    </button>
                    <button v-if="voucherType === 'buy' && !hasCheck && !isProducer && !buyReturn"
                            class="btn btn-success mr-2" @click="onTimeVoucherSubmitClicked">فروش همین فاکتور
                    </button>
                    <button type="button" class="d-inline-block btn btn-success m-1" @click="onPrintClicked"><i
                            class="fa fa-print"></i></button>

                    <button v-if="voucherType === 'sell' && !sellReturn && voucher.receiveOutSourceId === undefined" class="btn btn-success m-2"
                            @click="onCustomerAssignmentClicked">ثبت فروش و انتصاب مشتری
                    </button>
                    <button v-if="voucherType === 'sell' && !sellReturn && voucher.receiveOutSourceId !== undefined" class="btn btn-success m-2"
                            @click="onVoucherSubmitClicked">ثبت فروش
                    </button>
                    <button v-if="voucherType === 'sell' && sellReturn" class="btn btn-success m-2"
                            @click="onCustomerAssignmentClicked">ثبت مرجوعی و انتصاب مشتری
                    </button>
                    <button class="btn btn-warning m-2" data-toggle="modal" data-target="#paymentsData" v-if="!isProducer">مشاهده لیست
                        پرداخت
                    </button>
                    <button class="btn btn-primary m-2" data-toggle="modal" data-target="#voucherData">مشاهده فاکتور
                    </button>
                </div>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-lg-4" v-if="!isProducer">
                <div class="card archive radius" id="bank">
                    <div class="card-header headline bank glow-danger radius">
                        <h2 class="text-center text-white">بانک</h2>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-12 mb-3 product-container" v-for="(item, index) in banks">
                                <div :class="{active: isActive(item)}" class="card shadow pt-2 pb-2 payment"
                                     @click="onCardClicked($event, index, 'bank')">
                                    <div class="row p-2">
                                        <div class="col-lg-12">
                                            <h5 class="text-center">{{item.outSourceName}}</h5>
                                            <h6 class="text-center">{{item.accountNumber}}</h6>
                                            <h6 class="text-center"> موجودی :
                                                {{voucherType === 'sell' || sellReturn ? '---' : item.remain.toLocaleString()}}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12">
                                <div class="sk-circle" id="loading-bank">
                                    <div class="sk-circle1 sk-child"></div>
                                    <div class="sk-circle2 sk-child"></div>
                                    <div class="sk-circle3 sk-child"></div>
                                    <div class="sk-circle4 sk-child"></div>
                                    <div class="sk-circle5 sk-child"></div>
                                    <div class="sk-circle6 sk-child"></div>
                                    <div class="sk-circle7 sk-child"></div>
                                    <div class="sk-circle8 sk-child"></div>
                                    <div class="sk-circle9 sk-child"></div>
                                    <div class="sk-circle10 sk-child"></div>
                                    <div class="sk-circle11 sk-child"></div>
                                    <div class="sk-circle12 sk-child"></div>
                                </div>
                            </div>
                            <div class="col-lg-12 text-center mt-5">
                                <button class="btn btn-primary" data-toggle="modal" data-target="#bank-modal">افزودن
                                    بانک
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4" v-if="!isProducer">
                <div class="card archive radius" id="cashDesk">
                    <div class="card-header headline cash-desk glow-success radius">
                        <h2 class="text-center text-white">صندوق</h2>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-12 mb-3 product-container" v-for="(item, index) in cashDesks">
                                <div :class="{active: isActive(item)}" class="card shadow pt-2 pb-2 payment"
                                     @click="onCardClicked($event, index, 'cashDesk')">
                                    <div class="row p-2">
                                        <div class="col-lg-12">
                                            <h5 class="text-center">{{item.outSourceName}}</h5>
                                            <h6 class="text-center"> موجودی :
                                                {{voucherType === 'sell' || sellReturn ? '---' : item.remain.toLocaleString()}}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12">
                                <div class="sk-circle" id="loading-cash-desk">
                                    <div class="sk-circle1 sk-child"></div>
                                    <div class="sk-circle2 sk-child"></div>
                                    <div class="sk-circle3 sk-child"></div>
                                    <div class="sk-circle4 sk-child"></div>
                                    <div class="sk-circle5 sk-child"></div>
                                    <div class="sk-circle6 sk-child"></div>
                                    <div class="sk-circle7 sk-child"></div>
                                    <div class="sk-circle8 sk-child"></div>
                                    <div class="sk-circle9 sk-child"></div>
                                    <div class="sk-circle10 sk-child"></div>
                                    <div class="sk-circle11 sk-child"></div>
                                    <div class="sk-circle12 sk-child"></div>
                                </div>
                            </div>
                            <div class="col-lg-12 text-center mt-5">
                                <button class="btn btn-primary" data-toggle="modal" data-target="#cashDesk-modal">افزودن
                                    صندوق
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4" v-if="!isProducer">
                <div class="card archive radius" id="checkBook">
                    <div class="card-header headline check-book glow-info radius">
                        <h2 class="text-center text-white">چک</h2>
                    </div>
                    <div class="card-body">
                        <div class="row" v-if="voucherType === 'buy' && !buyReturn">
                            <div class="col-lg-12 mb-3 product-container" v-for="(item, index) in checkBooks">
                                <div :class="{active: isActive(item)}" class="card shadow pt-2 pb-2 payment"
                                     @click="onCardClicked($event, index, 'checkBook')">
                                    <div class="row p-2">
                                        <div class="col-lg-12">
                                            <h5 class="text-center">{{item.outSourceName}}</h5>
                                            <span>مبلغ: </span>
                                            <span>{{item.price.toLocaleString()}}</span>
                                            <span class="text-left">     تاریخ: </span>
                                            <span>{{item.checkPersianDate}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-else>
                            <div class="col-lg-12 mb-3 product-container" v-for="(item, index) in customerChecks">
                                <div :class="{active: isActive(item)}" class="card shadow pt-2 pb-2 payment">
                                    <div class="row p-2">
                                        <div class="col-lg-12">
                                            <h5 class="text-center">{{item.check.bankName}}</h5>
                                            <span>مبلغ: </span>
                                            <span>{{item.price.toLocaleString()}}</span>
                                            <br>
                                            <span>تاریخ چک: </span>
                                            <span>{{item.check.checkPersianDate}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12 text-center mt-5">
                                <button class="btn btn-primary" @click="newCheck">افزودن چک
                                </button>
                            </div>
                            <div class="col-lg-12">
                                <div class="sk-circle" id="loading-check-book">
                                    <div class="sk-circle1 sk-child"></div>
                                    <div class="sk-circle2 sk-child"></div>
                                    <div class="sk-circle3 sk-child"></div>
                                    <div class="sk-circle4 sk-child"></div>
                                    <div class="sk-circle5 sk-child"></div>
                                    <div class="sk-circle6 sk-child"></div>
                                    <div class="sk-circle7 sk-child"></div>
                                    <div class="sk-circle8 sk-child"></div>
                                    <div class="sk-circle9 sk-child"></div>
                                    <div class="sk-circle10 sk-child"></div>
                                    <div class="sk-circle11 sk-child"></div>
                                    <div class="sk-circle12 sk-child"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--<div v-if="vouchersBuy.length > 17" class="col-lg-12 text-center" @click="getProducts">
                <button class="btn btn-success">نمایش محصولات بیشتر</button>
            </div>-->
            <div class="modal fade" id="voucherData" tabindex="-1" role="dialog" aria-labelledby="voucherTitle"
                 aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div id="printMe">
                            <div class="modal-header bg-primary-grad glow-primary">
                                <h5 class="modal-title text-white" id="voucherTitle">محصولات فاکتور</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <div class="table-responsive">
                                    <table class="table table-hover table-striped">
                                        <thead>
                                        <tr>
                                            <th class="text-nowrap">نام محصول</th>
                                            <th v-if="voucherType === 'buy'" class="text-center text-nowrap">قیمت خرید</th>
                                            <th class="text-center text-nowrap" v-if="!isProducer">قیمت فروش</th>
                                            <th class="text-center text-nowrap">تعداد</th>
                                            <th class="text-center text-nowrap">تخفیف</th>
                                            <th class="text-center text-nowrap">مالیات</th>
                                            <th class="text-center text-nowrap">جمع</th>
                                        </tr>
                                        </thead>
                                        <tbody v-if="voucher !== undefined">
                                        <tr v-for="(item,index) in voucher.voucherProductDto">
                                            <!--<td class="product-remove-button"><a class="text-danger" @click="onRemoveProductClicked(index)"><i class="fa fa-close"></i></a></td>-->
                                            <td>{{item.productName}}</td>
                                            <td v-if="voucherType === 'buy'" class="text-center text-nowrap">
                                                {{item.price.toLocaleString()}}
                                            </td>
                                            <td class="text-center" v-if="!isProducer">
                                                {{item.salesPrice.toLocaleString()}}
                                            </td>
                                            <td class="text-center">
                                                {{item.unitVal}}
                                            </td>
                                            <td class="text-center">
                                                {{item.discount}}
                                            </td>
                                            <td class="text-center">
                                                {{item.taxPrice}}
                                            </td>
                                            <td class="text-center" v-if="!isProducer">
                                                {{voucherType === 'buy' ?((item.price - item.discount +item.taxPrice) * item.unitVal).toLocaleString() : ((item.salesPrice -
                                                item.discount) *
                                                item.unitVal).toLocaleString()}}
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    <h4 class="text-center mt-5"
                                        v-if="voucher !== undefined && voucher.voucherProductDto.length < 1">محصولی ثبت
                                        نشده
                                        است!</h4>
                                </div>
                                <div class="input-group mt-2">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">تخفیف فاکتور</span>
                                    </div>
                                    <span v-if="voucher !== undefined" class="form-control text-right">{{voucher.discount.toLocaleString()}}</span>
                                </div>
                                <div class="input-group mt-2">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">مالیات فاکتور</span>
                                    </div>
                                    <span class="form-control text-right">{{voucher !== undefined  && voucher.taxPrice !== undefined? voucher.taxPrice.toLocaleString() : 0}}</span>
                                </div>
                                <div class="input-group mt-2">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">توضیحات</span>
                                    </div>
                                    <span v-if="voucher !== undefined" class="form-control text-right">{{voucher.description}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer d-block">
                            <button type="button" class="btn btn-secondary mr-1" data-dismiss="modal">بستن</button>
                            <button type="button" class="btn btn-primary" @click="onModalEditClicked">ویرایش
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="payment" tabindex="-1" role="dialog" aria-labelledby="paymentTitle"
                 aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-warning-grad glow-warning">
                            <h5 class="modal-title text-white" id="paymentTitle">{{activePayment.name}}</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-lg-6 text-center  offset-lg-3">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">مبلغ</span>
                                        </div>
                                        <input class="form-control" type="number" v-model="activePayment.price"
                                               @input="thousandSeprator(activePayment.price)">
                                    </div>
                                    <small class="text-nowrap mt-2">{{activePayment.priceShow}}</small>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer d-block">
                            <button type="button" class="btn btn-secondary mr-1" data-dismiss="modal">بستن</button>
                            <button type="button" class="btn btn-success" @click="onPaymentModalOk">ثبت</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="paymentsData" tabindex="-1" role="dialog" aria-labelledby="paymentListTitle"
                 aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-success-grad glow-success">
                            <h5 class="modal-title text-white" id="paymentListTitle">لیست پرداخت ها</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="table-responsive">
                                <table class="table table-hover table-striped">
                                    <thead>
                                    <tr>
                                        <th></th>
                                        <th class="text-center text-nowrap">نام</th>
                                        <th class="text-center text-nowrap">کد</th>
                                        <th class="text-center text-nowrap">مبلغ</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(item,index) in payments">
                                        <td class="product-remove-button text-nowrap"><a class="text-danger"
                                                                                         @click="onRemovePaymentClicked(index)"><i
                                                class="fa fa-close"></i></a></td>
                                        <td class="text-center text-nowrap" v-if="item.code != ''">
                                            {{item.name}}
                                        </td>
                                        <td class="text-center text-nowrap" v-else>
                                            دسته چک
                                            {{item.check.bankName}}
                                        </td>
                                        <td class="text-center text-nowrap" v-if="item.code != ''">
                                            {{item.code}}
                                        </td>
                                        <td class="text-center text-nowrap" v-else>
                                            شماره چک
                                            {{item.check.checkNumber}}
                                        </td>
                                        <td class="text-center text-nowrap">
                                            {{item.price.toLocaleString()}}
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                                <h4 class="text-center mt-5" v-if="payments.length < 1">رکوردی ثبت نشده است!</h4>
                            </div>
                        </div>
                        <div class="modal-footer d-block">
                            <button type="button" class="btn btn-secondary mr-1" data-dismiss="modal">بستن</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="check" tabindex="-1" role="dialog" aria-labelledby="checkTitle"
                 aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-info-grad glow-info">
                            <h5 class="modal-title text-white" id="checkTitle">ایجاد چک جدید</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-lg-6 mb-2" v-if="(voucherType === 'buy' && !buyReturn)">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">دسته چک بانک</span>
                                        </div>
                                        <vs-select :data="banks" :mode="'create'"
                                                   :header="{multiple: false, label: 'outSourceName'}"
                                                   @onChange="onBankChange2"></vs-select>
                                    </div>
                                </div>
                                <div class="col-lg-6 mb-2" v-if="voucherType === 'sell'">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">چک مشتری </span>
                                        </div>
                                        <input class="form-control" type="text" readonly="true"
                                               v-model="checkCustomerSelected.outSourceName">

                                    </div>
                                </div>
                                <div class="col-lg-6 mb-2" v-if="(voucherType === 'sell' && !buyReturn) || (voucherType === 'buy' && buyReturn)">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">نام بانک</span>
                                        </div>
                                        <vs-select :data="bankList" :mode="'create'"
                                                   :header="{multiple: false, label: 'name'}"
                                                   @onChange="onBankChange"></vs-select>
                                    </div>
                                </div>
                                <div class="col-lg-6 mb-2" v-if="(voucherType === 'sell' && !buyReturn) || (voucherType === 'buy' && buyReturn) ">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">نام شعبه</span>
                                        </div>
                                        <input class="form-control" type="text"
                                               v-model="activePayment.check.branchName">
                                    </div>
                                </div>
                                <div class="col-lg-6 mb-2" v-if="(voucherType === 'sell' && !buyReturn) || (voucherType === 'buy' && buyReturn)">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">کد شعبه</span>
                                        </div>
                                        <input class="form-control" type="number"
                                               v-model="activePayment.check.branchCode">
                                    </div>
                                </div>
                                <div class="col-lg-6 mb-2">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">شماره چک</span>
                                        </div>
                                        <input class="form-control" type="number"
                                               v-model="activePayment.check.checkNumber">
                                    </div>
                                </div>
                                <div class="col-lg-6 mb-2">
                                    <div class="input-group mb-2">
                                        <div class="input-group-prepend" @click="toggleDatePicker">
                                            <div class="input-group-text"><span>تاریخ چک</span></div>
                                        </div>
                                        <date-picker type="date" format="jYYYY-jMM-jDD" @input="onDatePicked"
                                                     ref="datePicker" :auto-submit="true" style="flex: 1">
                                            <slot>
                                                <input v-model="activePayment.check.checkPersianDate"
                                                       class="form-control date-input" @click="toggleDatePicker">
                                                <button class="close reset-date" @click="resetDate">×</button>
                                            </slot>
                                        </date-picker>
                                    </div>
                                </div>
                                <div class="col-lg-6 mb-2 text-center">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">مبلغ</span>
                                        </div>
                                        <input class="form-control" type="number" v-model="activePayment.price"
                                               @input="thousandSeprator(activePayment.price)">
                                    </div>
                                    <small class="text-nowrap mt-2">{{activePayment.priceShow}}</small>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer d-block">
                            <button type="button" class="btn btn-secondary mr-1" data-dismiss="modal">بستن</button>
                            <button type="button" class="btn btn-success" @click="onCheckModalOk">ثبت</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="customer" tabindex="-1" role="dialog" aria-labelledby="customerTitle"
                 aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-danger-grad glow-danger">
                            <h5 class="modal-title text-white" id="customerTitle">لیست مشتریان</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-lg-12 mt-5" v-if="customers.length < 1">
                                    <h3 class="text-center no-item-alert">مشتری ثبت نشده است!</h3>
                                </div>
                                <div class="col-12 mt-2 mb-3 d-inline-block">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">مشتری :</span>
                                        </div>
                                        <vs-select :data="customers" :mode="'create'"
                                                   :header="{multiple: false, label: 'outSourceName'}"
                                                   @onChange="onCustomerClicked2"></vs-select>

                                    </div>
                                </div>
                                <div class="col-lg-3 mb-3" v-for="(item, index) in customers">
                                    <div class="card shadow" @click="onCustomerClicked(index)">
                                        <div class="row p-2">
                                            <div class="col-lg-12">
                                                <h5 class="text-center">{{item.outSourceName}}</h5>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div class="col-lg-12">
                                    <div class="sk-circle" id="loading-customer">
                                        <div class="sk-circle1 sk-child"></div>
                                        <div class="sk-circle2 sk-child"></div>
                                        <div class="sk-circle3 sk-child"></div>
                                        <div class="sk-circle4 sk-child"></div>
                                        <div class="sk-circle5 sk-child"></div>
                                        <div class="sk-circle6 sk-child"></div>
                                        <div class="sk-circle7 sk-child"></div>
                                        <div class="sk-circle8 sk-child"></div>
                                        <div class="sk-circle9 sk-child"></div>
                                        <div class="sk-circle10 sk-child"></div>
                                        <div class="sk-circle11 sk-child"></div>
                                        <div class="sk-circle12 sk-child"></div>
                                    </div>
                                </div>
                                <div v-if="customers.length > 17" class="col-lg-12 text-center mb-3"
                                     @click="getCustomers">
                                    <button class="btn btn-success">نمایش موارد بیشتر</button>
                                </div>
                                <div class="col-lg-12 text-center mt-5">
                                    <button class="btn btn-primary" data-toggle="modal" data-target="#customer-modal">افزودن
                                        مشتری
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer d-block">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">بستن</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ------------------------------------------------------------------------------------------->
        <div class="d-none" id="printMe222">
            <div class="text-center">
                <h4 v-if="voucherType === 'buy' && voucher.outSourceName !== ''" class="text-success">سند خرید از
                    {{voucher.outSourceName}}</h4>
                <h4 v-if="voucherType === 'sell'" class="text-success">سند فروش مشتری</h4>
            </div>
            <h5>محصولات فاکتور</h5>
            <div class="table-responsive">
                <table class="table table-hover table-striped">
                    <thead>
                    <tr>
                        <th class="text-nowrap">نام محصول</th>
                        <th class="text-center text-nowrap" v-if="voucherType === 'buy'">قیمت خرید</th>
                        <th class="text-center text-nowrap">قیمت فروش</th>
                        <th class="text-center text-nowrap">تعداد</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item,index) in voucher.voucherProductDto">
                        <td class="text-nowrap">{{item.productName}}</td>
                        <td class="text-center text-nowrap" v-if="voucherType === 'buy'">{{item.price}}</td>
                        <td class="text-center text-nowrap">{{item.unitVal}}</td>
                        <td class="text-center text-nowrap">{{item.salesPrice}}</td>
                    </tr>

                    <tr>
                        <td></td>
                        <td v-if="voucherType === 'buy'"></td>
                        <td class="text-center font-weight-bold">جمع فاکتور</td>
                        <td class="text-center font-weight-bold">{{voucher.overallPrice.toLocaleString()}}</td>
                    </tr>
                    </tbody>
                </table>

            </div>
            <h5 v-if="voucherType === 'buy'">منابع پرداخت</h5>
            <h5 v-if="voucherType === 'sell'">واریز به</h5>
            <div class="table-responsive">
                <table class="table table-hover table-striped">
                    <thead>
                    <tr>
                        <th></th>
                        <th class="text-center text-nowrap">نام</th>
                        <th class="text-center text-nowrap">کد</th>
                        <th class="text-center text-nowrap">مبلغ</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item,index) in payments">
                        <td class="product-remove-button text-nowrap"><a class="text-danger"
                                                                         @click="onRemovePaymentClicked(index)"><i
                                class="fa fa-close"></i></a></td>
                        <td class="text-center text-nowrap" v-if="item.code != ''">
                            {{item.name}}
                        </td>
                        <td class="text-center text-nowrap" v-else>
                            دسته چک
                            {{item.check.bankName}}
                        </td>
                        <td class="text-center text-nowrap" v-if="item.code != ''">
                            {{item.code}}
                        </td>
                        <td class="text-center text-nowrap" v-else>
                            شماره چک
                            {{item.check.checkNumber}}
                        </td>
                        <td class="text-center text-nowrap">
                            {{item.price.toLocaleString()}}
                        </td>
                    </tr>
                    </tbody>

                </table>

            </div>
        </div>
        <!-- ------------------------------------------------------------------------------------------->
        <div class="modal fade" id="bank-modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-warning-grad glow-warning">
                        <h5 class="modal-title text-white">افزودن حساب بانکی</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-lg-6 offset-lg-3 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">نام بانک</span>
                                    </div>
                                    <vs-select :data="bankList" :selected-val="preselectedBank" :mode="'create'"
                                               :header="{multiple: false, label: 'name'}"
                                               @onChange="onnewBankChange"></vs-select>
                                </div>
                            </div>
                            <div class="col-lg-6 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">شعبه</span>
                                    </div>
                                    <input class="form-control" type="text" v-model="bank.branchName">
                                </div>
                            </div>
                            <div class="col-lg-6 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">کد شعبه</span>
                                    </div>
                                    <input class="form-control" type="number" v-model="bank.branchCode">
                                </div>
                            </div>
                            <div class="col-lg-6 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">شماره کارت</span>
                                    </div>
                                    <input class="form-control" type="text" v-model="bank.kartNumber">
                                </div>
                            </div>
                            <div class="col-lg-6 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">شماره شبا</span>
                                    </div>
                                    <input class="form-control" type="text" v-model="bank.shebaCode">
                                </div>
                            </div>
                            <div class="col-lg-6 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">نوع حساب</span>
                                    </div>
                                    <vs-select :data="accountTypes" :selected-val="preselectedAccountType"
                                               :mode="'create'"
                                               :header="{multiple: false, label: 'name'}"
                                               @onChange="onAccountTypeChange"></vs-select>
                                </div>
                            </div>
                            <div class="col-lg-6 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">شماره حساب</span>
                                    </div>
                                    <input class="form-control" type="number" v-model="bank.accountNumber">
                                </div>
                            </div>
                        </div>
                        <div class="input-group mt-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text">توضیحات</span>
                            </div>
                            <input class="form-control" type="text" v-model="bank.description">
                        </div>
                    </div>
                    <div class="modal-footer d-block">
                        <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal">بستن</button>
                        <button type="button" class="btn btn-primary m-0" @click="onCreateBankModalOk">ذخیره</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="cashDesk-modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-warning-grad glow-warning">
                        <h5 class="modal-title text-white">افزودن صندوق</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-lg-6 offset-lg-3 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">نام صندوق</span>
                                    </div>
                                    <input class="form-control" type="text" v-model="cashDesk.outSourceName">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer d-block">
                        <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal">بستن</button>
                        <button type="button" class="btn btn-primary" @click="onCreateCashModalOk">ذخیره</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="customer-modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-warning-grad glow-warning">
                        <h5 class="modal-title text-white">افزودن مشتری</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-lg-6 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">نام مشتری</span>
                                    </div>
                                    <input class="form-control" type="text" v-model="customer.outSourceName">
                                </div>
                            </div>
                            <div class="col-lg-6 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">شماره تماس</span>
                                    </div>
                                    <input class="form-control" type="number" v-model="customer.phoneNumber">
                                </div>
                            </div>
                            <div class="col-lg-6 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">کد ملی</span>
                                    </div>
                                    <input class="form-control" type="number" v-model="customer.branchCode">
                                </div>
                            </div>
                            <!--<div class="col-lg-4 mb-2">-->
                            <!--<div class="input-group">-->
                            <!--<div class="input-group-prepend">-->
                            <!--<span class="input-group-text">کد اقتصادی</span>-->
                            <!--</div>-->
                            <!--<input class="form-control" type="number" v-model="customer.shebaCode">-->
                            <!--</div>-->
                            <!--</div>-->
                            <div class="col-lg-6 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">کد پستی</span>
                                    </div>
                                    <input class="form-control" type="number" v-model="customer.accountNumber">
                                </div>
                            </div>
                            <div class="col-lg-12 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">آدرس</span>
                                    </div>
                                    <input class="form-control" type="text" v-model="customer.address">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer d-block">
                        <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal">بستن</button>
                        <button type="button" class="btn btn-primary m-0" @click="onCustomerModalOk">ذخیره</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import * as $ from 'jquery';
    import axios from 'axios';
    import Vue from 'vue';
    import BaseService from "../_framework/api/BaseService";
    import Utils from "../_framework/utils/Utils";
    import VsSelect from "../_framework/VsSelect"
    import DatePicker from '../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue';
    import Moment from 'moment-jalali';
    import VueHtmlToPaper from 'vue-html-to-paper';

    $(function () {
        var pos1 = 0;
        $(window).scroll(function () {
            var pos2 = $(window).scrollTop();
            if (pos2 > pos1) {
                $(".search-area").addClass("hidden");
            }
            if (pos1 > pos2) {
                $(".search-area").removeClass("hidden");
            }
            pos1 = pos2;
        })
    });

    //$(".product-container:nth-child(1)").css("background-color","green");
    $(".voucher-modal-button").click(() => {
        $("#voucherData").modal("show");
    });

    export default {
        name: 'payment',
        components: {
            VsSelect,
            DatePicker
        },
        data() {
            return {
                checkCustomerSelected: {id: 0, outSourceName: ""},
                sellReturn: false,
                buyReturn: false,
                banks: [],
                cashDesks: [],
                checkBooks: [],

                voucherType: "",
                remainingAmount: 0,

                activePayment: {
                    code: "",
                    price: 0,
                    name: "",
                    check: {
                        checkNumber: "",
                        checkDate: "",
                        checkPersianDate: "",
                        bankName: "",
                        branchName: "",
                        branchCode: ""
                    }
                },

                hasCheck: false,
                archivedVoucher: false,
                customerChecks: [],

                payments: [],
                customers: [],


                queryParams: {
                    pageSize: 10000,
                    pageIndex: 0,
                    types: 1
                },

                voucher: {
                    description: "",
                    serveOutSourceId: 0,
                    voucherProductDto: [],
                    overallPrice: 0,
                    overallAmount: 0
                },
                bankList: [
                    {name: "کشاورزی"},
                    {name: "انصار"},
                    {name: "آینده"},
                    {name: "بانک مرکزی"},
                    {name: "بانک شهر"},
                    {name: "دی"},
                    {name: "اقتصاد نوین"},
                    {name: "گردشگری"},
                    {name: "قوامین"},
                    {name: "کارافرین"},
                    {name: "مسکن"},
                    {name: "مهر"},
                    {name: "ملت"},
                    {name: "ملی"},
                    {name: "پارسیان"},
                    {name: "پاسارگاد"},
                    {name: "پست بانک"},
                    {name: "رفاه"},
                    {name: "رسالت"},
                    {name: "صادرات"},
                    {name: "صنعت و معدن"},
                    {name: "سرمایه"},
                    {name: "سپه"},
                    {name: "سینا"},
                    {name: "تجارت"},
                    {name: "سرمایه"},
                ],

                userId: 0,
                companyId: 0,
                isPaying: false,
                bank: {
                    branchName: "",
                    branchCode: "",
                    kartNumber: "",
                    shebaCode: "",
                    accountType: "",
                    accountNumber: "",
                    description: "",
                    outSourceName: "بانک",
                    accountOwner: "",
                    type: 1
                },
                preselectedBank: {},
                preselectedAccountType: {},
                accountTypes: [
                    {
                        id: 1,
                        name: "جاری"
                    },
                    {
                        id: 2,
                        name: "قرض الحسنه"
                    },
                    {
                        id: 3,
                        name: "سپرده"
                    },
                    {
                        id: 4,
                        name: "تسهیلات"
                    }
                ],
                cashDesk: {
                    outSourceName: "",
                    type: 2
                },
                customer: {
                    phoneNumber: "",
                    address: "",
                    outSourceName: "",
                    type: 3
                },
                isProducer: false,
                producerMobile: "",
                companyPostName: "",
                isSending: false,


            }
        },
        mounted() {
            this.companyPostName = localStorage.getItem("companyPostName");

            if (this.companyPostName === 'تامین کننده') {
                this.isProducer = true;
                this.producerMobile = localStorage.getItem("phoneNumber");
            }
            const printoptions = {
                name: '_blank',
                specs: [
                    'fullscreen=yes',
                    'titlebar=yes',
                    'scrollbars=yes'
                ],
                styles: [
                    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
                    'https://unpkg.com/kidlat-css/css/kidlat.css'
                ]
            };
            Vue.use(VueHtmlToPaper, printoptions);
            this.userId = localStorage.getItem("userId");
            this.companyId = localStorage.getItem("companyId");
            // if (this.$route.params.type === undefined) {
            //     this.$router.push({name: "home"});
            // }
            // console.log(this.$route.params);
            this.voucherType = this.$route.params.type;
            this.voucher = this.$route.params.voucher;
            console.log(this.voucher)
            if (this.voucher === undefined || this.voucher === null) {
                this.$noty.error("متاسفانه خطایی رخ داده مجددا تلاش کنید!");
                setTimeout(() => {
                    this.$router.push({name: 'home'});
                }, 200);
            }
            if (this.$route.params.sellReturn !== undefined && this.$route.params.sellReturn !== null) {
                this.sellReturn = this.$route.params.sellReturn;
            }
            if (this.$route.params.buyReturn !== undefined && this.$route.params.buyReturn !== null) {
                this.buyReturn = this.$route.params.buyReturn;
            }
            this.remainingAmount = this.voucher.overallPrice;

            if (this.voucher.type !== undefined && this.voucher.voucherIndex !== undefined) {
                this.archivedVoucher = true;
            } else {
                this.archivedVoucher = false;
            }

            this.getBanks();
            this.getCaches();
            this.queryParams.types = 12;
            this.queryParams.checkStatus = 0;
            new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                this.checkBooks = response.data.data;
                if (this.checkBooks.length > 0) {
                    for (let check of this.checkBooks) {
                        check.checkPersianDate = Moment(check.checkDate, 'YYYY-MM-DD').format('jDD jMMMM jYYYY');
                    }
                }
                $("#loading-check-book").hide();
            }).catch(error => {
                // error
                Utils.handleErrorWithNotification(error.response.message, this.$noty);
            });

            this.getCustomers();


        },
        methods: {
            getCustomers() {
                this.queryParams.types = 3;
                delete this.queryParams.checkStatus;
                new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                    this.customers = response.data.data;

                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.response.message, this.$noty);
                });
            },
            getCaches() {
                this.queryParams.types = 2;
                new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                    this.cashDesks = response.data.data;
                    $("#loading-cash-desk").hide();
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.response.message, this.$noty);
                });

            },
            getBanks() {
                this.queryParams.types = 1;
                new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                    this.banks = response.data.data;
                    $("#loading-bank").hide();
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.response.message, this.$noty);
                });

            },
            onCardClicked(e, index, type) {
                this.activePayment.name = "";
                this.activePayment.code = "";
                this.activePayment.price = 0;
                if (type === 'bank') {
                    this.activePayment.price = this.remainingAmount;
                    this.activePayment.name = this.banks[index].outSourceName;
                    this.activePayment.code = this.banks[index].code;
                }
                if (type === 'cashDesk') {
                    this.activePayment.price = this.remainingAmount;
                    this.activePayment.name = this.cashDesks[index].outSourceName;
                    this.activePayment.code = this.cashDesks[index].code;
                }
                if (type === 'checkBook') {
                    this.activePayment.name = this.checkBooks[index].outSourceName;
                    this.activePayment.code = this.checkBooks[index].code;
                    this.activePayment.price = this.checkBooks[index].price;

                }
                $("#payment").modal("show");
                for (let item of this.payments) {
                    if (item.code === this.activePayment.code) {
                        this.activePayment.price = item.price;
                    }
                }

                this.thousandSeprator(this.activePayment.price);
            },
            newCheck() {

                this.checkCustomerSelected.outSourceName = this.voucher.receiveOutSourceName;
                this.checkCustomerSelected.id = this.voucher.receiveOutSourceId;
                this.activePayment.check.checkExporterBankId = this.voucher.receiveOutSourceId;
                this.activePayment.price = this.remainingAmount;
                $("#check").modal("show");
            },
            onModalShow() {
                $("#voucherData").modal("show");
            },
            onModalEditClicked() {
                $("#voucherData").modal("hide");
                if (this.voucherType === "buy") {
                    let obj = {
                        name: 'buy-from-outsource',
                        params: {
                            id: this.voucher.serveOutSourceId,
                            voucher: this.voucher
                        }
                    };
                    this.$router.push(obj);
                } else {
                    let obj = {
                        name: 'sell',
                        params: {
                            voucher: this.voucher,
                            id: this.voucher.receiveOutSourceId,
                            outSourceName: this.voucher.receiveOutSourceName
                        }
                    };
                    this.$router.push(obj);
                }
            },
            onPaymentModalOk() {
                let payment = JSON.parse(JSON.stringify(this.activePayment));
                payment.price = parseInt(payment.price);
                //this.remainingAmount -= payment.price;
                //this.activePayment.price = parseInt(this.activePayment.price);
                if (this.payments.length < 1) {
                    this.payments.push(payment);
                } else {
                    let flag = false;
                    for (let item of this.payments) {
                        if (item.code === payment.code) {
                            item.price = payment.price;
                            flag = true;
                        }
                    }
                    if (flag === false) {
                        this.payments.push(payment);
                    }
                }
                this.activePayment.price = 0;
                this.activePayment.code = "";
                this.activePayment.name = "";
                $("#payment").modal("hide");

            },
            onRemovePaymentClicked(index) {
                this.payments.splice(index, 1);
            },
            isActive(object) {
                for (let item of this.payments) {
                    if (item.code === object.code) {
                        return true;
                    }
                }
                return false;
            },
            onBankChange(val) {
                if ((this.voucherType === 'sell' && !this.buyReturn) || (this.voucherType === 'buy' && this.buyReturn)) {
                    this.activePayment.check.bankName = val.name;
                } else {
                    this.activePayment.check.bankName = val.outSourceName;
                }
            },
            onBankChange2(val) {
                console.log(this.voucherType)
                if (this.voucherType === 'buy') {
                    this.activePayment.check.checkExporterBankId = val.id;

                } else {
                    this.activePayment.check.checkExporterBankId = val.id;
                    this.checkCustomerSelected = val;
                }
            },
            toggleDatePicker() {
                this.$refs.datePicker.togglePicker();
            },
            onDatePicked(val) {
                this.activePayment.check.checkDate = Moment(val, 'jYYYY-jMM-jDD').format('YYYY-MM-DD');
                this.activePayment.check.checkPersianDate = Moment(val, 'jYYYY-jMM-jDD').format('jDD jMMMM jYYYY');
            },
            resetDate() {
                this.activePayment.check.checkPersianDate = '';
                this.activePayment.check.checkDate = '';
            },
            onCheckModalOk() {
                console.log(this.voucherType === 'sell' &&  this.activePayment.check.bankName === undefined )
                if (this.voucherType === 'sell' &&  (this.activePayment.check.bankName === undefined || this.activePayment.check.bankName === null || this.activePayment.check.bankName === '') ){
                    this.$noty.error("لطفا بانک را انتخاب کنید");
                } else if (this.activePayment.check.checkNumber === undefined || this.activePayment.check.checkNumber === null || this.activePayment.check.checkNumber === '') {
                    this.$noty.error("لطفا شماره چک را وارد کنید");
                } else if (this.activePayment.check.checkPersianDate === undefined || this.activePayment.check.checkPersianDate === null || this.activePayment.check.checkPersianDate === '') {
                    this.$noty.error("لطفا تاریخ چک را انتخاب کنید");
                } else if (this.activePayment.price === undefined || this.activePayment.price === null || this.activePayment.price === '' || this.activePayment.price == 0) {
                    this.$noty.error("لطفامبلغ چک را وارد کنید");
                } else {
                    let payment = JSON.parse(JSON.stringify(this.activePayment));

                    payment.price = parseInt(payment.price);
                    payment.check.rowVersion = this.generateUuid();
                    this.payments.push(payment);
                    if ((this.voucherType === 'sell' && !this.buyReturn) || (this.voucherType === 'buy' && this.buyReturn)) {
                        this.hasCheck = true;
                    }
                    this.customerChecks.push(payment);
                    Utils.resetObject(this.activePayment.check);
                    this.activePayment.price = 0;
                    this.activePayment.code = "";
                    $("#check").modal('hide');
                }
            },
            onVoucherSubmitClicked() {
                if (this.voucher !== undefined && this.voucher.id !== undefined && this.voucher.id !== null) {
                    this.restPayment();
                }
                if (isNaN(this.voucher.receiveOutSourceId)) {
                    this.voucher.receiveOutSourceId = parseInt(this.companyId);
                }
                if (isNaN(this.voucher.serveOutSourceId)) {
                    // this.voucher.serveOutSourceId = parseInt(this.companyId);
                    this.voucher.serveCompanyId = parseInt(this.companyId);
                }
                for (let item of this.payments) {
                    if (item.check === null || item.check.checkNumber === null || item.check.checkNumber === "") {
                        item.check = null;
                    }
                }
                if (this.remainingAmount < 0) {
                    if (confirm("مبلغ باقیمانده منفی میشود و مبلغ " + this.remainingAmount + " طلبکار خواهید شد. آیا میخواهید سند را ثبت کنید؟")) {
                        this.sendCreateRequest();
                    }

                } else if (this.remainingAmount > 0) {
                    if (confirm("سند بطور کامل پرداخت نمیشود و مبلغ " + this.remainingAmount + " باقی می ماند، آیا میخواهید سند را ثبت کنید؟")) {
                        this.sendCreateRequest();
                    }
                } else {

                    this.sendCreateRequest();
                }
            },
            sendCreateRequest() {
                if (this.voucher.voucherDate === undefined || this.voucher.voucherDate === null || this.voucher.voucherDate === "" || this.voucher.voucherDate === "0001-01-01") {
                    this.voucher.voucherDate = Moment(new Date()).format('YYYY-MM-DD');
                }
                if (this.checkVoucherDateInSalemali(this.voucher.voucherDate)) {
                    if (!this.isPaying) {
                        this.isPaying = true;
                        if (this.buyReturn) {
                            new BaseService('voucher', '/createbuyReturn').create(this.voucher).then(response => {
                                let voucherId = response.data.data;
                                new BaseService('voucher', `/paymentsellReturn/${voucherId}`).create(this.payments).then(response => {
                                    this.$noty.success("سند با موفقیت ثبت شد!");

                                    this.isPaying = false;
                                    this.$router.push({name: 'home'});
                                }).catch(error => {
                                    this.isPaying = false;
                                    this.$noty.error(error.response.message);
                                    Utils.handleErrorWithNotification(error.response.message, this.$noty);
                                })
                            }).catch(error => {
                                this.isPaying = false;
                                this.$noty.error(error.response.message);
                                Utils.handleErrorWithNotification(error.response.message, this.$noty);
                            });
                        }
                        if (this.sellReturn) {
                            new BaseService('voucher', '/createsellReturn').create(this.voucher).then(response => {
                                let voucherId = response.data.data;
                                new BaseService('voucher', `/paymentsellReturn/${voucherId}`).create(this.payments).then(response => {
                                    this.$noty.success("سند با موفقیت ثبت شد!");

                                    $("#customer").modal("hide");
                                    this.isPaying = false;
                                    this.$router.push({name: 'home'});
                                }).catch(error => {
                                    this.isPaying = false;
                                    this.$noty.error(error.response.message);
                                    Utils.handleErrorWithNotification(error.response.message, this.$noty);
                                })
                            }).catch(error => {
                                this.isPaying = false;
                                this.$noty.error(error.response.message);
                                Utils.handleErrorWithNotification(error.response.message, this.$noty);
                            });
                        }
                        if (!this.sellReturn && !this.buyReturn) {
                            new BaseService('voucher').create(this.voucher).then(response => {
                                let voucherId = response.data.data;
                                new BaseService('voucher', `/payment/${voucherId}`).create(this.payments).then(response => {
                                    this.$noty.success("سند با موفقیت ثبت شد!");
                                    if (this.archivedVoucher) {
                                        this.removeVoucherFromArchives(this.voucher.type, this.voucher.voucherIndex);
                                    }
                                    $("#customer").modal("hide");
                                    this.isPaying = false;
                                    this.$router.push({name: 'home'});
                                }).catch(error => {
                                    this.isPaying = false;
                                    this.$noty.error(error);
                                    Utils.handleErrorWithNotification(error.response.message, this.$noty);
                                })
                            }).catch(error => {
                                this.isPaying = false;
                                this.$noty.error(error);
                                Utils.handleErrorWithNotification(error.response.message, this.$noty);
                            });
                        }
                    }
                }
            },
            restPayment() {
                if (this.voucher.voucherDate === undefined || this.voucher.voucherDate === null || this.voucher.voucherDate === "" || this.voucher.voucherDate === "0001-01-01") {
                    this.voucher.voucherDate = Moment(new Date()).format('YYYY-MM-DD');
                }
                if (this.checkVoucherDateInSalemali(this.voucher.voucherDate)) {
                    if (!this.isPaying) {
                        this.isPaying = true;
                        for (let item of this.payments) {
                            if (item.check === null || item.check.checkNumber === null || item.check.checkNumber === "") {
                                item.check = null;
                            }
                        }
                        new BaseService('voucher', `/payment/${this.voucher.id}`).create(this.payments).then(response => {
                            this.$noty.success("سند با موفقیت ثبت شد!");
                            if (this.archivedVoucher) {
                                this.removeVoucherFromArchives(this.voucher.type, this.voucher.voucherIndex);
                            }
                            $("#customer").modal("hide");
                            this.isPaying = false;
                            this.$router.push({name: 'home'});
                        }).catch(error => {
                            this.isPaying = false;
                            this.$noty.error(error);
                            Utils.handleErrorWithNotification(error.response.message, this.$noty);
                        })
                    }
                }
            },
            onTimeVoucherSubmitClicked() {
                if (this.voucher.voucherDate === undefined || this.voucher.voucherDate === null || this.voucher.voucherDate === "" || this.voucher.voucherDate === "0001-01-01") {
                    this.voucher.voucherDate = Moment(new Date()).format('YYYY-MM-DD');
                }
                if (this.checkVoucherDateInSalemali(this.voucher.voucherDate)) {
                    if (!this.isPaying) {
                        this.isPaying = true;
                        this.getCustomers();
                        if (isNaN(this.voucher.receiveOutSourceId)) {
                            this.voucher.receiveOutSourceId = parseInt(this.companyId);
                        }
                        if (isNaN(this.voucher.serveOutSourceId)) {
                            // this.voucher.serveOutSourceId = parseInt(this.companyId);
                            this.voucher.serveCompanyId = parseInt(this.companyId);
                        }
                        for (let item of this.payments) {
                            if (item.check === null || item.check.checkNumber === null || item.check.checkNumber === "") {
                                item.check = null;
                            }
                        }
                        if (this.remainingAmount < 0) {
                            if (confirm("مبلغ باقیمانده منفی میشود و مبلغ " + this.remainingAmount + " طلبکار خواهید شد. آیا میخواهید سند را ثبت کنید؟")) {
                                new BaseService('voucher').create(this.voucher).then(response => {
                                    let voucherId = response.data.data;
                                    new BaseService('voucher', `/payment/${voucherId}`).create(this.payments).then(response => {
                                        this.$noty.success("سند با موفقیت ثبت شد!");
                                        this.isPaying = false;
                                        this.voucherType = 'sell';
                                        let over = 0;
                                        for (let i of this.voucher.voucherProductDto) {
                                            over = over + (i.salesPrice * i.unitVal);
                                        }
                                        this.remainingAmount = over;
                                        this.voucher.overallPrice = over;
                                        this.voucher.receiveOutSourceId = null;
                                        this.voucher.serveOutSourceId = null;
                                        this.voucher.serveCompanyId = parseInt(this.companyId);
                                        // this.voucher = {
                                        //     description: "",
                                        //     serveOutSourceId: null,
                                        //     overallPrice: over,
                                        //     receiveOutSourceId:null,
                                        // };
                                        this.activePayment = {
                                            code: "",
                                            price: 0,
                                            name: "",
                                            check: {
                                                checkNumber: "",
                                                checkDate: "",
                                                checkPersianDate: "",
                                                bankName: "",
                                                branchName: "",
                                                branchCode: ""
                                            }
                                        };
                                        this.payments = [];

                                        // this.$router.push({name: 'home'});
                                    }).catch(error => {
                                        this.isPaying = false;
                                        Utils.handleErrorWithNotification(error.response.message, this.$noty);
                                    })
                                }).catch(error => {
                                    this.isPaying = false;
                                    Utils.handleErrorWithNotification(error.response.message, this.$noty);
                                });
                            }
                        } else if (this.remainingAmount > 0) {
                            if (confirm("سند بطور کامل پرداخت نمیشود و مبلغ " + this.remainingAmount + " باقی می ماند، آیا میخواهید سند را ثبت کنید؟")) {
                                new BaseService('voucher').create(this.voucher).then(response => {
                                    let voucherId = response.data.data;
                                    new BaseService('voucher', `/payment/${voucherId}`).create(this.payments).then(response => {
                                        this.$noty.success("سند با موفقیت ثبت شد!");
                                        this.isPaying = false;
                                        this.voucherType = 'sell';
                                        let over = 0;
                                        for (let i of this.voucher.voucherProductDto) {
                                            over = over + (i.salesPrice * i.unitVal);
                                        }
                                        this.remainingAmount = over;
                                        this.voucher.overallPrice = over;
                                        this.voucher.receiveOutSourceId = null;
                                        this.voucher.serveOutSourceId = null;
                                        this.voucher.serveCompanyId = parseInt(this.companyId);
                                        // this.voucher = {
                                        //     description: "",
                                        //     serveOutSourceId: null,
                                        //     overallPrice: over,
                                        //     receiveOutSourceId:null,
                                        // };
                                        this.activePayment = {
                                            code: "",
                                            price: 0,
                                            name: "",
                                            check: {
                                                checkNumber: "",
                                                checkDate: "",
                                                checkPersianDate: "",
                                                bankName: "",
                                                branchName: "",
                                                branchCode: ""
                                            }
                                        };
                                        this.payments = [];
                                    }).catch(error => {
                                        this.isPaying = false;
                                        Utils.handleErrorWithNotification(error.response.message, this.$noty);
                                    })
                                }).catch(error => {
                                    this.isPaying = false;
                                    Utils.handleErrorWithNotification(error.response.message, this.$noty);
                                });
                            }
                        } else {

                            new BaseService('voucher').create(this.voucher).then(response => {
                                let voucherId = response.data.data;
                                new BaseService('voucher', `/payment/${voucherId}`).create(this.payments).then(response => {
                                    this.$noty.success("سند با موفقیت ثبت شد!");
                                    // $("#customer").modal("hide");
                                    this.isPaying = false;
                                    this.voucherType = 'sell';
                                    let over = 0;
                                    for (let i of this.voucher.voucherProductDto) {
                                        over = over + (i.salesPrice * i.unitVal);
                                    }
                                    this.remainingAmount = over;
                                    this.voucher.overallPrice = over;
                                    this.voucher.receiveOutSourceId = null;
                                    this.voucher.serveOutSourceId = null;
                                    this.voucher.serveCompanyId = parseInt(this.companyId);
                                    // this.voucher = {
                                    //     description: "",
                                    //     serveOutSourceId: null,
                                    //     overallPrice: over,
                                    //     receiveOutSourceId:null,
                                    // };
                                    this.activePayment = {
                                        code: "",
                                        price: 0,
                                        name: "",
                                        check: {
                                            checkNumber: "",
                                            checkDate: "",
                                            checkPersianDate: "",
                                            bankName: "",
                                            branchName: "",
                                            branchCode: ""
                                        }
                                    };
                                    this.payments = [];
                                }).catch(error => {
                                    this.isPaying = false;
                                    Utils.handleErrorWithNotification(error.response.message, this.$noty);
                                })
                            }).catch(error => {
                                this.isPaying = false;
                                Utils.handleErrorWithNotification(error.response.message, this.$noty);
                            });
                        }
                    }
                }
            },
            onCustomerAssignmentClicked() {
                if (this.voucher !== undefined && this.voucher.id !== undefined && this.voucher.id !== null) {
                    this.restPayment();
                }
                if (!this.isPaying) {
                    this.isPaying = true;
                    // if (isNaN(this.voucher.serveOutSourceId)) {
                    //     this.voucher.serveOutSourceId = this.companyId;
                    // }
                    if (isNaN(this.voucher.receiveOutSourceId)) {
                        this.voucher.receiveOutSourceId = parseInt(this.companyId);
                    }
                    if (isNaN(this.voucher.serveOutSourceId)) {
                        // this.voucher.serveOutSourceId = parseInt(this.companyId);
                        this.voucher.serveCompanyId = parseInt(this.companyId);
                    }

                    if (this.remainingAmount < 0) {
                        this.$noty.error("مبلغ باقیمانده منفی میباشد!");
                        this.isPaying = false;
                    } else if (this.remainingAmount > 0) {
                        if (confirm("سند بطور کامل پرداخت نمیشود و مبلغ " + this.remainingAmount + " باقی می ماند، آیا میخواهید سند را ثبت کنید؟")) {
                            this.queryParams.types = 3;
                            delete this.queryParams.checkStatus;
                            new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                                this.customers = response.data.data;
                                $("#loading-customer").hide();
                                this.isPaying = false;
                                $("#customer").modal("show");
                            }).catch(error => {
                                this.isPaying = false;
                                Utils.handleErrorWithNotification(error.response.message, this.$noty);
                            });
                        }
                    } else {
                        this.queryParams.types = 3;
                        delete this.queryParams.checkStatus;
                        new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                            this.customers = response.data.data;
                            $("#loading-customer").hide();
                            this.isPaying = false;
                            $("#customer").modal("show");
                        }).catch(error => {
                            this.isPaying = false;
                            Utils.handleErrorWithNotification(error.response.message, this.$noty);
                        });
                    }
                }
            },
            onCustomerClicked(index) {
                this.voucher.receiveOutSourceId = this.customers[index].id;
                this.onVoucherSubmitClicked();
            },
            onCustomerClicked2(val) {
                if (val && val.id !== null) {
                    this.voucher.receiveOutSourceId = val.id;
                    this.onVoucherSubmitClicked();
                }
            },
            removeVoucherFromArchives(type, index) {
                if (type === 'buy') {
                    let archives = JSON.parse(localStorage.getItem(`tempVoucherBuy${this.userId}${this.companyId}`));
                    archives.splice(index, 1);
                    localStorage.setItem(`tempVoucherBuy${this.userId}${this.companyId}`, JSON.stringify(archives));
                } else {
                    let archives = JSON.parse(localStorage.getItem(`tempVoucherSell${this.userId}${this.companyId}`));
                    archives.splice(index, 1);
                    localStorage.setItem(`tempVoucherSell${this.userId}${this.companyId}`, JSON.stringify(archives));
                }
            },
            onPrintClicked() {
                this.$htmlToPaper('printMe');
            },
            thousandSeprator(a) {
                let amount = a;
                let showprice = "";
                if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
                    showprice = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                } else {
                    showprice = amount;
                }
                this.activePayment.priceShow = showprice;
            },
            onnewBankChange(e) {
                this.bank.accountOwner = e.name;
            },
            onAccountTypeChange(e) {
                this.bank.accountType = e.id;
            },
            onCreateBankModalOk() {

                if (this.bank.accountOwner === null || this.bank.accountOwner === '' || this.bank.accountOwner === undefined) {
                    Utils.handleErrorWithNotification("لطفا بانک را وارد کنید", this.$noty);
                } else if (this.bank.branchName === null || this.bank.branchName === '' || this.bank.branchName === undefined) {
                    Utils.handleErrorWithNotification("لطفا نام شعبه را وارد کنید", this.$noty);
                } else if (this.bank.accountType === null || this.bank.accountType === '' || this.bank.accountType === undefined) {
                    Utils.handleErrorWithNotification("لطفا نوع حساب را وارد کنید", this.$noty);
                } else if (this.bank.accountNumber === null || this.bank.accountNumber === '' || this.bank.accountNumber === undefined) {
                    Utils.handleErrorWithNotification("لطفا شماره حساب را وارد کنید", this.$noty);
                } else {
                    this.onCreateBank(this.bank);
                }

            },
            onCreateBank(bank) {
                if (!this.isSending) {
                    this.isSending = true;
                    bank.rowVersion = this.generateUuid();
                    this.bank.outSourceName = this.bank.accountOwner;
                    new BaseService('outsource').create(bank).then(response => {
                        this.$noty.success("حساب بانکی با موفقیت افزوده شد.");
                        this.queryParams.pageIndex = 0;

                        // Utils.resetObject(this.bank);
                        this.preselectedBank = {};
                        this.preselectedAccountType = {};
                        this.getBanks();
                        $("#bank-modal").modal("hide");
                        this.isSending = false;
                    }).catch(error => {
                        this.isSending = false;
                        Utils.handleErrorWithNotification(error.data.message, this.$noty);
                    });
                }
            },
            onCreateCashModalOk() {
                this.onCashCreate(this.cashDesk);
            },
            onCashCreate(cashDesk) {
                if (!this.isSending) {
                    this.isSending = true;
                    cashDesk.rowVersion = this.generateUuid();
                    new BaseService('outsource').create(cashDesk).then(response => {
                        this.$noty.success("صندوق با موفقیت افزوده شد.");
                        this.getCaches();
                        $("#cashDesk-modal").modal("hide");
                        this.isSending = false;
                    }).catch(error => {
                        this.isSending = false;
                        Utils.handleErrorWithNotification(error.message, this.$noty);
                    });
                }
            },
            onCustomerModalOk() {
                this.onCustomerCreate(this.customer);
            },
            onCustomerCreate(customer) {
                if (!this.isSending) {
                    this.isSending = true;
                    customer.rowVersion = this.generateUuid();
                    new BaseService('outsource').create(customer).then(response => {
                        this.$noty.success("اطلاعات مشتری با موفقیت افزوده شد.");
                        $("#customer-modal").modal("hide");
                        this.getCustomers();
                        this.isSending = false;
                    }).catch(error => {
                        this.isSending = false;
                        Utils.handleErrorWithNotification(error.message, this.$noty);
                    });
                }
            },

        },
        beforeRouteLeave(to, from, next) {
            $(window).unbind('scroll');
            if ($("#voucherData").hasClass("show")) {
                $("#voucherData").modal("hide");
                next(false);
            } else {
                if ($("#payment").hasClass("show")) {
                    $("#payment").modal("hide");
                    next(false);
                } else {
                    if ($("#paymentsData").hasClass("show")) {
                        $("#paymentsData").modal("hide");
                        next(false);
                    } else {
                        if ($("#check").hasClass("show")) {
                            $("#check").modal("hide");
                            next(false);
                        } else {
                            if ($("#customer").hasClass("show")) {
                                $("#customer").modal("hide");
                                next(false);
                            } else {
                                next();
                            }
                        }
                    }
                }
            }


        },
        // beforeRouteLeave(to, from, next) {
        //     try {
        //         $(".modal").modal('hide');
        //     } catch(e) {}
        //     next();
        // },
        watch: {
            payments: {
                handler(val) {
                    let sum = 0;
                    for (let item of val) {
                        sum += item.price;
                    }
                    this.remainingAmount = this.voucher.overallPrice - sum;
                    if (this.remainingAmount === 0 && this.voucherType === 'sell' && !this.sellReturn && this.voucher.receiveOutSourceId !== undefined) {
                        this.onVoucherSubmitClicked();
                    }

                },
                deep: true
            }
        }
    }
</script>